import { getManagerNavAction } from '../manager/manager-nav-registry.js';
import { getMemberNavAction } from '../members/member-nav-registry.js';

let registeredShowAlertMsg = null;

export function registerShowAlertMsg(fn) {
    if (typeof fn !== 'function') {
        throw new Error('registerShowAlertMsg: fn is required');
    }
    registeredShowAlertMsg = fn;
}

export function resolveShowAlertMsg() {
    if (typeof registeredShowAlertMsg === 'function') {
        return registeredShowAlertMsg;
    }
    try {
        return getManagerNavAction('showAlertMsg');
    } catch {
        try {
            return getMemberNavAction('showAlertMsg');
        } catch {
            return null;
        }
    }
}
